module.exports = __webpack_public_path__ + "/bundle/asset/plan-2-c2ccd923c0d3d37853b7f6cf231533fd.png";